import { Row, Col, Upload, Modal, Form, Button, message, Divider } from "antd";
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import * as XLSX from "xlsx";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";
import { DownloadExcel, SampleFileDownload } from "./ExcelFile";
const { Dragger } = Upload;

const ImportForm = ({
  path,
  sectionName,
  show,
  hide,
  existingData,
  refresh,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [importFile, setImportFile] = useState([]);
  const [file, setFile] = useState([]);
  const fileType = [
    ".csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const handleImport = (info) => {
    const { file, fileList } = info;
    
    if (fileList?.length) {
      
      if (!fileType.includes(file.type)) {
        return ShowToast("File format is not correct", Severty.WARNING);
      }

      const fileData = {
        lastModified      :   file.lastModified,
        lastModifiedDate  :   file.lastModifiedDate,
        name              :   file.name,
        uid               :   file.uid,
        status            :   "done",
        originFileObj     :   file.originFileObj,
        size              :   file.size,
        type              :   file.type,
        percent           :   file.percent,
      };

      setFile([fileData]);
      parseExcel(file.originFileObj);

    } else {
      return ShowToast("Missing Excel File.", Severty.WARNING);
    }
  };

  const parseExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data            =   new Uint8Array(e.target.result);
      const workbook        =   XLSX.read(data, { type: "array" });
      const firstSheetName  =   workbook.SheetNames[0];
      const worksheet       =   workbook.Sheets[firstSheetName];
      const parsedData      =   XLSX.utils.sheet_to_json(worksheet);
      
      setImportFile(parsedData);
    };

    reader.readAsArrayBuffer(file);
  };

  const onImport = () => {
    if (file?.length > 0) {
      setLoading(true);
      const payload = {};
      payload.import_file = importFile;
      request({
        url: path,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          console.log(error);
          ShowToast(error, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      return ShowToast("Please Select an Ecxel File.", Severty.WARNING);
    }
  };

  const renderItem = (originNode, file) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '15px' }}>
      
      <span className="text-black"> {file.name} </span>
      
      <Button style={{ color: 'white', backgroundColor: 'red', border: 'none' }} type="text" icon={<DeleteOutlined />}
        onClick={(e) => {
          setFile([])
          setImportFile([])
        }}
      >
        Remove File
      </Button>
      
    </div>
  );

  return (
    <Modal
      open={show}
      title="Import Excel"
      okText="Import"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onImport} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item name="import_file">
              
              <div className="text-center">
                <Button
                  className="w-100"
                  title="Download Sample File"
                  onClick={() => {
                    SampleFileDownload(sectionName);
                  }}
                >
                  <i className="fas fa-download"></i>&nbsp;&nbsp;Sample File
                </Button>
              </div>

              <div className="text-left mt-1 mb-1">
                <span className="text-danger"> Instructions  </span>
                  <br/> 1) The column names must match exactly as provided in the sample file.
                  <br/> 2) If no data is available for a field, please leave it blank.
              </div>

              <Dragger
                fileList={file}
                onRemove={(e) => {
                  setFile([])
                  setImportFile([])
                }}
                maxCount={1}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleImport}
                customRequest={(e) => null}
                itemRender={renderItem}
              >
                <p className="ant-upload-drag-icon">{" "} <InboxOutlined />{" "} </p>
                
                <p className="ant-upload-text"> Click or Drag File to This Area to Upload </p>
                <p className="ant-upload-hint">Please Select an Excel File.</p>
              
              </Dragger>
              
              {error && <div style={{ color: "red", padding: 5 }}>{error}</div>}

            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ImportForm;
